<template>
  <div class="rounds">
    <div v-if="loading"
         class="loader">
      <div class="bar"></div>
    </div>
    <Header @load="loadPage"
            @search="searchData"
            @setFilters="setFilters">
    </Header>
    <div class="rounds-data">
      <Table :descending="descending"
             :data="rounds"
             :headers="headers"
             :selected="selectedColumns"
             :sortColumn="paginationConfig.sortBy"
             :sortable="true"
             @sortBy="sortRoundsBy"
             :type="'list'">
      </Table>
      <Pagination :page="page"
                  :row="pagination.rowsPerPage"
                  :rows="rowsPerPageItems"
                  :totalItems="totalCount"
                  :totalPages="totalPages"
                  @setPages="setPagination">
      </Pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { map } from 'lodash';
import { paginable } from '../mixins';
import Header from './Header';
import Pagination from './Pagination';
import Table from './Table';

export default {
  name: 'Rounds',
  components: {
    Header,
    Pagination,
    Table,
  },
  mixins: [
    paginable,
  ],
  data() {
    return {
      headers: [
        { value: 'id' },
        { value: 'round' },
        { value: 'result' },
        { value: 'createdAt' },
        { value: 'resolvedAt' },
        { value: 'rtp' },
        { value: 'totalStake' },
        { value: 'totalPaymentTax' },
        { value: 'totalPayment' },
        { value: 'totalPayout' },
        { value: 'totalPayoutTax' },
        { value: 'totalPayoutAfterTax' },
        { value: 'status', config: true },
      ],
      descending: false,
      dateFrom: null,
      dateTo: null,
      page: null,
      search: null,
      selectedColumns: [],
      totalPages: null,
    };
  },
  computed: {
    ...mapGetters([
      'wheel',
      'paginationConfig',
      'platformTimezoneOffset',
      'rounds',
    ]),
    apiFilters() {
      return {
        wheelId: this.wheel.id,
        wheelAccountId: this.wheel.wheelAccountId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        timezoneOffset: this.platformTimezoneOffset,
      };
    },
  },
  watch: {
    apiFilters() {
      this.loadPage();
    },
  },
  mounted() {
    this.selectedColumns = map(this.headers, () => true);
  },
  methods: {
    loadPage() {
      if (this.wheel.id) {
        this.loading = true;
        this.$store.dispatch('loadRounds', this.apiParams).then((result) => {
          this.totalPages = result.pagination.totalPages;
          this.page = result.pagination.page;
          this.totalCount = result.pagination.totalCount;
          this.descending = this.pagination.descending;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    sortRoundsBy(value) {
      this.pagination.sortBy = value;
      this.pagination.descending = !this.pagination.descending;
      this.loadPage();
    },
    setPagination(value) {
      this.pagination.page = value.page;
      this.pagination.rowsPerPage = value.pageSize;
      this.loadPage();
    },
    setFilters(value) {
      this.dateFrom = value.dateFrom;
      this.dateTo = value.dateTo;
    },
    searchData(value) {
      this.search = value;
      this.loadPage();
    },
  },
};
</script>
<style lang="scss" scoped>
.rounds-data {
  padding: 10px;
  width: 100%;
  table {
    th {
      &:first-child {
        width: 100px;
      }
    }
  }
  .pagination {
    width: 99.9%;
  }
}
@media only screen and (max-width: 750px) {
  .rounds {
    .navigation-items {
      margin-top: 0;
    }
    .date-range-container {
      margin-top: 13px;
    }
  }
}
</style>
